module.exports = __webpack_public_path__ + "sx9-6e94bd12.png";